"use strict";

exports.__esModule = true;

var _electrodeElectrifyReactComponent = require("./components/electrode-electrify-react-component");

var _electrodeElectrifyReactComponent2 = _interopRequireDefault(_electrodeElectrifyReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _electrodeElectrifyReactComponent2.default;


//////////////////
// WEBPACK FOOTER
// ../~/electrode-electrify-react-component/lib/index.js
// module id = 416
// module chunks = 0